import React, { useContext } from "react";
import { exact, number, shape, string } from "prop-types";
import styles from "./BuildingLoadingEventRow.module.styl";
import { toDateStringLocale, toDateStringLocaleShort } from "utils";
import { MediaContext } from "app/media/MediaContext";

export default function BuildingLoadingEventRow({ eventData }) {
    const { isTablet } = useContext(MediaContext);
    let startDate = isTablet
        ? toDateStringLocaleShort(eventData.dateInterval.start)
        : toDateStringLocale(eventData.dateInterval.start);
    let endDate = isTablet
        ? toDateStringLocaleShort(eventData.dateInterval.end)
        : toDateStringLocale(eventData.dateInterval.end);

    return (
        <div className={styles.row}>
            <div>{eventData.name}</div>
            <div>{eventData.sportType}</div>
            <div>{eventData.eventType}</div>
            <div>{eventData.eventStatus}</div>
            <div>{startDate}</div>
            <div>{endDate}</div>
        </div>
    );
}

BuildingLoadingEventRow.propTypes = {
    eventData: exact({
        id: number.isRequired,
        name: string.isRequired,
        dateInterval: shape({
            start: string.isRequired,
            end: string.isRequired,
        }).isRequired,
        eventStatus: string.isRequired,
        eventType: string.isRequired,
        sportType: string.isRequired,
        locationName: string.isRequired,
    }),
};
